import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=07f17c83&"
import script from "./PromotionList.vue?vue&type=script&lang=ts&"
export * from "./PromotionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports